"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./PlaceholderImageWrapper.style"));

function PlaceholderImageWrapper(_ref) {
  var children = _ref.children,
      isLoaded = _ref.isLoaded;

  var _react_1$useState = react_1.useState(true),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isShowPlaceHolder = _react_1$useState2[0],
      setShowPlaceHodler = _react_1$useState2[1];

  return jsx_runtime_1.jsx("div", Object.assign({
    css: [styles.wrapper, isLoaded && styles.transparent, !isShowPlaceHolder && styles.hidden],
    onTransitionEnd: function onTransitionEnd() {
      setShowPlaceHodler(false);
    }
  }, {
    children: children
  }), void 0);
}

exports.default = react_1.memo(PlaceholderImageWrapper);